import * as React from "react"

function SvgTime(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 17 17" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 16.017A7.517 7.517 0 118.5.983a7.517 7.517 0 010 15.034zm0-1.367a6.15 6.15 0 100-12.3 6.15 6.15 0 000 12.3zm3.417-6.833H9.183V4.4H7.817v4.783h4.1V7.817z"
        fill="#E54A2D"
      />
    </svg>
  )
}

export default SvgTime

